/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@material-ui/core';
import { ExpandLess } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import { useStyles } from './styles';
import { useApiError, useAppData, useLoading } from '../../providers';
import { Header, NotificationIcon, PageTitle } from '../../components';
import { useCommonStyles } from '../../styles';
import { updateNotificationStatus } from './NotificationService';
import { Notification } from '../../models';
import { convertUTCDateToLocal } from '../../utils';

export const NotificationsPage: FC = () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const location = useLocation();
  const { translations } = useAppData();
  const { setIsLoading } = useLoading();
  const { addError } = useApiError();
  const [translation, setTranslation] = useState<any>([]);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [expanded, setExpanded] = useState<string | false>(false);

  const markAsRead = useCallback(
    async (notification) => {
      if (!notification.isRead) {
        setIsLoading(true);
        try {
          await updateNotificationStatus({
            notificationObjId: notification.id,
            isRead: true,
          });
          notification.isRead = true;
        } catch (error) {
          addError(JSON.stringify(error.response));
        } finally {
          setIsLoading(false);
        }
      }
    },
    [addError, setIsLoading],
  );

  const handleExpandedAccordionChange = async (notification: Notification) => {
    if (!notification.isRead) {
      await markAsRead(notification);
    }
    setExpanded(expanded === notification.id ? false : notification.id);
  };

  useEffect(() => {
    setTranslation(JSON.parse(translations));
  }, [translations]);

  useEffect(() => {
    const props = location.state as Notification[];
    setNotifications(props);

    if (props.length === 1) {
      (async () => {
        await handleExpandedAccordionChange(props[0]);
      })();
    }
  }, [location]);

  return (
    <>
      <Header title={translation.text_1618} />
      <Grid container direction="column" className={classes.root}>
        <PageTitle title={translation.text_1618} />
        <Grid container direction="column" className={commonClasses.mainContainer}>
          <Grid item xs={12} className={commonClasses.contentWithAccordion}>
            {notifications.map((notification: any) => (
              <Accordion classes={{ root: commonClasses.accordion }} key={notification.id} expanded={expanded === notification.id} onChange={() => handleExpandedAccordionChange(notification)}>
                <AccordionSummary classes={{ content: commonClasses.accordionContent }} expandIcon={<ExpandLess />}>
                  <NotificationIcon />
                  <Grid item xs={9} className={classes.message}>
                    <Grid item className={classes.title}>
                      {notification.type === 'ClientAssignedUnderPartnership'
                        ? translation.new_client_assigned
                        : notification.type === '12'
                        ? `${translation.cashback_campaign} ${notification.message.payload.Name} ${translation.deactivated_due_to_end_date}`
                        : notification.message}
                    </Grid>
                    <Grid item className={classes.time}>
                      {convertUTCDateToLocal(notification.dateCreated, 'DD/MM/yyyy HH:mm')}
                    </Grid>
                    {!notification.isRead && (
                      <Grid item className={classes.status}>
                        {translation.text_15}
                      </Grid>
                    )}
                  </Grid>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.accordionDetails }}>
                  <Grid item xs={12}>
                    {notification.type === 'ClientAssignedUnderPartnership' && Object.keys(notification.message.payload || {}).length > 0 ? (
                      <Grid container direction="column">
                        <Grid item xs={12} className={classes.detailsRow}>
                          <Grid container direction="row" className={classes.detailsItem}>
                            <Grid item xs={6} className={classes.columnName}>
                              {translation.text_6275}
                            </Grid>
                            <Grid item xs={6} className={classes.columnValue}>
                              {notification.message.payload.partnershipCode}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.detailsRow}>
                          <Grid container direction="row" className={classes.detailsItem}>
                            <Grid item xs={6} className={classes.columnName}>
                              {translation.client_name}
                            </Grid>
                            <Grid item xs={6} className={classes.columnValue}>
                              {notification.message.payload.clientName}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.detailsRow}>
                          <Grid container direction="row" className={classes.detailsItem}>
                            <Grid item xs={6} className={classes.columnName}>
                              {translation.trading_account}
                            </Grid>
                            <Grid item xs={6} className={classes.columnValue}>
                              {notification.message.payload.tradingAccount}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.detailsRow}>
                          <Grid container direction="row" className={classes.detailsItem}>
                            <Grid item xs={6} className={classes.columnName}>
                              {translation.text_1333}
                            </Grid>
                            <Grid item xs={6} className={classes.columnValue}>
                              {notification.message.payload.email}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : notification.type === '12' && Object.keys(notification.message.payload).length > 0 ? (
                      <Grid container direction="row" alignItems="flex-start" alignContent="flex-start" className={classes.messageRow}>
                        <p>{`${translation.the_cashback_campaign} ${notification.message.payload.Name} ${translation.campaign_deactivated_message}`}</p>
                      </Grid>
                    ) : (
                      <Grid container direction="row" alignItems="flex-start" alignContent="flex-start" className={classes.messageRow}>
                        notification.message.body
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
